/* eslint-disable jsx-a11y/anchor-is-valid */
import  {FC} from 'react'
const InviteUsers: FC = () => {
  return (
    <div className='modal fade' id='kt_modal_invite_friends' aria-hidden='true'>
    </div>
  )
}

export {InviteUsers}
